import { Modal } from './modal';
import * as SidebarNotes from './sidebarNotes';
import { NotePackageService } from '../services/notePackageService';
import { INotePackageData } from '../dto/INotePackageData';

const service = new NotePackageService();

export function initialize() {
    bindButtons(new Modal('.modal-export-notes'), $('.js-export-notes'));
}

function bindButtons(modal: Modal, $triggerButton: JQuery): void {
    const $modal = modal.getReference();
    const selector = modal.getSelector();
    const $view = $modal.find(selector + '__view');
    const $exportButton = $modal.find(selector + '__export-button:first');
    const $sendButton = $modal.find(selector + '__send-button:first');

    $exportButton.on('click', (event) => handleExport(event, $view, $modal));
    $sendButton.on('click', (event) => handleSend(event, $modal, modal));
    $triggerButton.on('click', () => {
        showViewOne($view);
        $modal.find('form[name="form"]:first').trigger('reset');
        modal.show();
    });
}

function handleExport(event: any, $view: JQuery, $modal: JQuery): void {
    event.preventDefault();

    const name = $modal.find('input[name="name"]:first').val();
    const noteIds = SidebarNotes.getSelectedNotes().map((note) => note.id);

    if (!name || !noteIds.length) {
        return;
    }

    service.exportNotes(
        name as string,
        noteIds,
        (notePackage: INotePackageData) => handleShare($view, $modal, notePackage),
        () => alert('Tillfälligt fel: Kan inte exportera anteckningar')
    );
}

function handleShare($view: JQuery, $modal: JQuery, notePackage: INotePackageData) {
    const $urlInput = $modal.find('input[name="url"]:first');
    $urlInput.val(notePackage.shareUrl);
    showViewTwo($view);
}

function extractQueryKeyValue(url: string, key: string): string {
    const queries = url.slice(url.indexOf('?') + 1).split('&');

    for (const query of queries) {
        const splitQuery = query.split('=');
        if (splitQuery[0] === key) {
            return splitQuery[1];
        }
    }

    return undefined;
}

function handleSend(event: any, $modal: JQuery, modal: Modal): void {
    event.preventDefault();

    const emailRegex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const emails = ($modal.find('input[name="mail"]:first').val() as string)
        .split(',')
        .map((email) => email.trim())
        .filter((email) => emailRegex.test(email));
    const url = $modal.find('input[name="url"]:first').val() as string;
    const id = extractQueryKeyValue(url, 'share');

    if (!id.length || !emails.length) {
        return;
    }

    service.emailExportedNotes(
        id,
        emails,
        () => modal.close(),
        () => alert('Tillfälligt fel: Kan inte skicka exporterade anteckningar')
    );
}

function showViewOne($view: JQuery) {
    $view.hide();
    $view.eq(0).show();
}

function showViewTwo($view: JQuery) {
    $view.hide();
    $view.eq(1).show();
}